import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=b2aee552&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/balance.css?vue&type=style&index=0&id=b2aee552&scoped=true&lang=css&"
import style1 from "./Balance.vue?vue&type=style&index=1&id=b2aee552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aee552",
  null
  
)

export default component.exports